import { app } from '../../../../../app';
import { azureDomainsFromDto, domainsFromDto, isAzure, emptyDomainListCheck } from './directory.functions';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory', {
        url: '/directory/:directoryId',
        params: {directoryId: 'saaspass-cloud-directory'},
        componentProvider,
        resolve: {
            $breadcrumbs,
            connectionDetails,
            directory,
            directoryId,
            domains,
            groups,
        },
    });
}

/** @ngInject */
function componentProvider(directoryId) {
    if (directoryId === 'saaspass-cloud-directory') {
        return 'companyUserDirectoriesDirectoryGroupsSaaspassCloudDirectory';
    } else {
        return 'companyUserDirectoriesDirectoryGroupsDirectory';
    }
}

/** @ngInject */
function $breadcrumbs(directory) {
    return [{title: directory.name}];
}

/** @ngInject */
function connectionDetails(companyId, DirectoriesResource, directory) {
    if (directory.id !== 'saaspass-cloud-directory' && !isAzure(directory)) {
        return DirectoriesResource.getDirectoryConnectionDetails(companyId, directory.id);
    }
}

/** @ngInject */
function directory(directories, directoryId) {
    return directories.find(({id}) => id === directoryId);
}

/** @ngInject */
function directoryId($stateParams) {
    return $stateParams.directoryId;
}

/** @ngInject */
function domains($filter, companyId, DirectoriesResource, directory) {
    if (directory.id !== 'saaspass-cloud-directory') {
        if (!isAzure(directory)) {
            return DirectoriesResource
            .getDirectoryGroups(companyId, directory)
            .then((domains) => $filter('orderBy')(domains, 'isRoot', true))
            .then(domainsFromDto)
            .then((domains) => {
                return emptyDomainListCheck(directory, domains);
            })
        } else {
            return DirectoriesResource
            .getDirectoryGroups(companyId, directory)
            .then(azureDomainsFromDto)
        }
    }
}

/** @ngInject */
function groups(companyId, DirectoriesResource, directoryId) {
    if (directoryId === 'saaspass-cloud-directory') {
        return DirectoriesResource.getSaaspassCloudDirectoryGroups(companyId);
    } else {
        return [];
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/directory.state.js